import { Routes, Route } from "react-router-dom";
import EngagePlan from "./components/Clientpanel/EngagementPlanner/EngagePlan";
import { AuthProvider } from "./hooks/useEngageAuth";
import { MerchantProvider } from "./hooks/useMerchant";

const EngageRoutes = () => {
  return (
    <AuthProvider>
      <MerchantProvider>
      <Routes>
        <Route path="overview" element={<EngagePlan />} />
        <Route path="automations" element={<EngagePlan />} />
        <Route path="events" element={<EngagePlan />} />
        <Route path="blast" element={<EngagePlan />} />
        <Route path="analytics" element={<EngagePlan />} />
        <Route path="customers/:id" element={<EngagePlan />} />
        <Route path="customers" element={<EngagePlan />} />
        <Route path="templates/:templatid/edit" element={<EngagePlan />} />
        <Route path="templates/:gtemplatid/grapesjs" element={<EngagePlan />} />
        <Route path="templates" element={<EngagePlan />} />
        <Route path="settings" element={<EngagePlan />} />
      </Routes>
      </MerchantProvider>
    </AuthProvider>
  );
};

export default EngageRoutes;